import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import 'rxjs/add/operator/debounceTime';
import { Filter } from '../../class/filter';

@Component({
  selector: 'filter-component',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {
  @Input() filter:Filter;
  @Output() toSearch = new EventEmitter<Object>();
  
  constructor() {}
  
  private search = new FormControl();
  private model = { search: '', filter: '__all' }
  ngOnInit(){
    this.search.valueChanges.debounceTime(600).subscribe(a => {
      if(this.model.search != a){
        if(a != ''){
          this.model.search = a;
          if(this.model.filter != '__all'){
            this.toSearch.emit("&search="+this.model.search+"&filter="+this.model.filter);
          }else{
            this.toSearch.emit("&search="+this.model.search);
          }
        }else{
          this.model.search = a;
          this.toSearch.emit("");
        }
      }
    });
  }
  private onChange(value:any){
    if(this.model.search != ''){
      if(value != '__all'){
        this.toSearch.emit("&search="+this.model.search+"&filter="+value);
      }else{
        this.toSearch.emit("&search="+this.model.search);
      }
    }else{
      this.toSearch.emit("");
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/component/filter/filter.component.ts